import React from "react";
import EmailSignup from "./components/EmailSignup";

export default function AboutUs() {
  function handleJoinWaitlistLink() {
    // Scroll to top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Focus the email input after a brief delay to ensure scroll is initiated
    setTimeout(() => {
      const emailInput = document.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.focus();
      }
    }, 100);
  }

  return (
    <div>
      {/* Header */}
      <header className="header">
        <div className="logo" style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/'}>
          <img alt="Light Reads logo" className="logo-img" src="/logo-quote.png" />
          <span className="logo-text">Light Reads</span>
        </div>
        <nav className="nav nav-light">
          <span style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/about'}>For Authors and Publishers</span>
          <span style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/about'}>About us</span>
        </nav>
      </header>

      {/* Hero Section with Email Signup */}
      <EmailSignup 
        title='Every Story Deserves <span class="hero-title-accent">a Voice.</span>'
        buttonText="Join Waitlist"
        successMessage="Thanks for joining! We'll be in touch soon."
      />

      {/* We believe section */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 1.5rem' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '400', marginBottom: '2rem' }}>We believe that human expression is sacred.</h2>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          That's why our mission is simple: to help storytellers and publishers bring their work to life in the most immersive, powerful way possible.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
          We're building AI tools that amplify human creativity, not replace it.
        </p>
      </section>

      {/* Why Light Reads Exists */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '400', marginBottom: '2rem' }}>Why Light Reads Exists.</h2>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          People love books, but life gets in the way. We believe audiobooks and visual storytelling aren't just nice extras. They're essential for helping stories reach busy, modern lives.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          And yet, of the 20 million books available online, fewer than 10% exist as audiobooks. The rest remain unread, unheard, undiscovered.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          We're here to change that.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1rem', lineHeight: '1.6' }}>
          With Lightreads, authors and publishers can instantly turn their books into:
        </p>
        <ul className="serif" style={{ fontSize: '1.1rem', lineHeight: '1.6', paddingLeft: '1.5rem' }}>
          <li>Multi-voice audiobooks with cinematic, humanlike narration</li>
          <li>Hollywood-style trailers for TikTok, YouTube and beyond</li>
          <li>Visual picture books—audio-backed, beautifully illustrated story videos</li>
          <li>Interactive books, where readers can talk to characters in real time (coming soon)</li>
        </ul>
      </section>

      {/* Obsessively High Quality Audio */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '400', marginBottom: '2rem' }}>Obsessively High Quality Audio.</h2>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          Audio is everything.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          We don't treat narration like an add-on. We treat it like art. That's why we obsess over every detail: pacing, tone, clarity, pronunciation, emotional nuance. If it doesn't sound beautiful, it doesn't ship.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
          We use the world's most advanced AI voice technology, carefully tuned for storytelling, and we tailor every output to match the voice of the author or publisher. This isn't generic, robotic narration, it's studio-grade performance, built for books that deserve to be heard.
        </p>
      </section>

      {/* Built for Authors and Publishers */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '400', marginBottom: '2rem' }}>Built for Authors and Publishers. Trusted by Readers.</h2>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          We know writers and publishers are wary of AI, and they should be. Too many tools are built to automate creativity, to replace human voices, or to flood the world with generic, soulless content.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          We are the opposite. We don't generate books. We don't write for you. And we don't believe creativity should be outsourced to machines.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          We believe authors are irreplaceable, and that storytelling is a human act. Our tools simply help you express your story more fully—on more platforms, in more formats, and in a way that fits the world today.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
          Think of us as your production team: the lighting, the sound, the stage. You wrote the story, we're here to help it shine.
        </p>
      </section>

      {/* Who Are We */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '400', marginBottom: '2rem' }}>Who Are We.</h2>
        <p className="serif" style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          We're the team behind <a href="https://www.obooko.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', color: 'inherit' }}>Obooko</a>, one of the world's largest free eBook libraries. Over the years, we've helped millions of readers discover indie books, and now, with Lightreads, we're helping those books to life.
        </p>
        <p className="serif" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
          Our mission is to increase the total reading time of humanity. We want stories to be heard as well as read, and for authors and publishers to have the tools they need to reach their audiences, however and wherever they listen.
        </p>
      </section>

      {/* Launching Soon */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 1.5rem', textAlign: 'center' }}>
        <p className="serif" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
          <strong>Launching Soon, be first in line to let your book be heard ♡</strong> <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={handleJoinWaitlistLink}>Join the Waitlist &gt;</span>
        </p>
      </section>

      {/* Footer */}
      <footer className="footer">
        Designed and built with love in Melbourne 📚 © Saturn Program Returns Pty Ltd 2025
        <span className="footer-link">Privacy Policy</span>
        <span className="footer-link">Terms & Conditions</span>
      </footer>
    </div>
  );
}